<template>
  <div class="totalDepositAndWithdrawalStatusTable">
    <v-data-table
      :headers="tableHeaders"
      :items="items"
      :hide-default-header="false"
      hide-default-footer
      class="rounded-lg"
      :items-per-page="-1"
      :no-data-text="noDataText"
    >
      <template v-slot:[`item.totalAmount`]="{ item: tableItem }">
        <span class="font-weight-bold baseText_2--text">
          {{
            `${formatPrice(tableItem.totalAmount).toLocaleString()}${getUnit(
              tableItem.currencyId
            )}`
          }}
        </span>
      </template>
      <template v-slot:[`item.totalDoneAmount`]="{ item: tableItem }">
        <span class="font-weight-bold baseText_2--text">
          {{
            `${formatPrice(
              tableItem.totalDoneAmount
            ).toLocaleString()}${getUnit(tableItem.currencyId)}`
          }}
        </span>
      </template>
      <template v-slot:[`item.totalStillAmount`]="{ item: tableItem }">
        <span class="font-weight-bold error--text">
          {{
            `${formatPrice(
              tableItem.totalStillAmount
            ).toLocaleString()}${getUnit(tableItem.currencyId)}`
          }}
        </span>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { currencyUtil, commonUtil } from '@/util'

export default {
  name: 'TotalWithdrawalStatusTable',
  components: {},
  props: {
    items: {
      type: Array,
      default: () => []
    },
    headers: {
      type: Array,
      default: () => []
    },
    paymentType: {
      type: String,
      default: 'order' // or sale
    }
  },
  data: () => ({}),
  created() {},
  methods: {
    getUnit(currencyId) {
      return currencyUtil.findCurrencyNameById(currencyId).unitName
    },
    formatPrice(price) {
      return commonUtil.formatPrice(price)
    },
    ...mapActions('Order', ['getOrderDetailListFromApi']),
    ...mapGetters('Order', ['getOrderDetailListFromState'])
  },
  computed: {
    tableHeaders() {
      const headersTmp = this.headers.map((header) => {
        const tmp = { ...header }
        tmp.text = this.$t(tmp.text)
        return tmp
      })
      return headersTmp
    },
    noDataText() {
      return this.paymentType === 'order'
        ? this.$t('sale.sale_order-not-selected')
        : this.$t('payment.payment_sale-not-selected')
    }
  }
}
</script>
<style lang="scss" scoped>
.totalDepositAndWithdrawalStatusTable {
  ::v-deep .v-data-table th {
    background-color: rgba(151, 198, 234, 0.1);
    padding-left: 30px;
  }
  ::v-deep .v-data-table td {
    padding-left: 30px;
  }
}
</style>
